import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment as env } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class LgvTSHelper {

    public static formattedPhoneNumber(origNumber: string, useDots = false): string {

        if (typeof origNumber == 'undefined' || !origNumber) {
            return origNumber
        }

        // strip non numeric
        let phoneNumber = origNumber.replace(/\D/g, '');
        let len = phoneNumber.length;

        if(len > 11){
            phoneNumber = phoneNumber.substring(0, 11);
            len = phoneNumber.length;
        }

        if (useDots) {
            if (len == 7) { return phoneNumber.replace(/(\d\d\d)(\d\d\d\d)/, "$1.$2"); }
            if (len == 10) { return phoneNumber.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, "$1.$2.$3"); }
            if (len == 11) { return phoneNumber.replace(/(\d)(\d\d\d)(\d\d\d)(\d\d\d\d)/, "$1 $2.$3.$4"); }
        }
        else {
            if (len == 7) { return phoneNumber.replace(/(\d\d\d)(\d\d\d\d)/, "$1-$2"); }
            if (len == 10) { return phoneNumber.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, "($1) $2-$3"); }
            if (len == 11) { return phoneNumber.replace(/(\d)(\d\d\d)(\d\d\d)(\d\d\d\d)/, "$1 ($2) $3-$4"); }
        }

        // unsupported format / length
        return origNumber;
    }

    public static stringToNumber(x): number {
        if (x == null || x == undefined) {
            return 0;
        }

        let rtnVal = 0;
        if (typeof x === 'string') {
            rtnVal = parseFloat(x.replace(/\$|,/g, ''));
        }
        else {
            rtnVal = parseFloat(x.toString().replace(/\$|,/g, ''));
        }

        return isNaN(rtnVal) ? 0 : rtnVal;
    }

    public static numberWithCommas(x: string): string {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static stringIsNullOrEmpty(x: string): boolean {
        return !x || x === "";
    }

    public static isValidEmail(email: string): boolean {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    public static jsonDateToJSDate(jsonDate: any): Date {
        if (!jsonDate) {
            return null;
        }

        try {
            //    const datePipe = new DatePipe('en-US');
            //    return new Date(datePipe.transform(jsonDate, 'yyyy-MM-dd'));

            return LgvTSHelper.dateUTCToLocal(new Date(jsonDate));

        } catch (err) {
            return null;
        }
    }

    public static utcDate(): Date {
        return new Date(Date.parse(new Date().toUTCString().replace("GMT", "")));
    }

    public static jsDateToJsonDate(d: Date, justDate = false): string {
        const datePipe = new DatePipe('en-US');
        return datePipe.transform(d, justDate ? 'yyyy-MM-dd' : 'yyyy-MM-ddTHH:mm:ss');
    }

    public static jsonDateToDateTimeString(strDate:string): string {
        const datePipe = new DatePipe('en-US');
        let d = new Date(strDate);
        return datePipe.transform(d, 'E, M/d/yyyy h:mm a');
    }

    public static utcDateAsJsonDate(): string {
        return LgvTSHelper.jsDateToJsonDate(LgvTSHelper.utcDate());
    }

    public static dateLocalToUTC(d: Date) {
        const utcTimeString = d.toUTCString();
        const dateNumber = Date.parse(utcTimeString.replace("GMT", ""));
        return new Date(dateNumber);
    }

    public static dateUTCToLocal(d: Date) {
        const datePipe = new DatePipe('en-US');
        const localDateStr = datePipe.transform(d, 'yyyy-MM-dd HH:mm:ss UTC');
        return new Date(localDateStr);
    }

    public static dateTester() {
        const datePipe = new DatePipe('en-US');

        console.log('====================== Date Tester ======================');

        console.log();
        console.log('***  Original Date ***');

        const newDate = new Date();
        console.log(newDate);

        console.log('***  Convert to UTC ***');
        const utcDate = this.dateLocalToUTC(newDate);
        console.log(utcDate);

        console.log('***  Convert to Local ***');
        console.log(this.dateUTCToLocal(utcDate));

        console.log('***  Convert WS DateTime string ***');

        let wsDateStr = "2024-07-29T20:44:54.8454195+00:00"; // 7/29/24 1:44pm
        console.log(`wsDateStr: ${wsDateStr}`);

        let jsDate = new Date(wsDateStr);
        console.log(`jsDate: ${jsDate}`);


        console.log('=========================================================');
    }

    public static monthDiff(d1: Date, d2: Date) {
        //console.log(`Comparing: ${d1.toDateString()} vs ${d2.toDateString()}`);

        let months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months;
    }

    public static monthsAgo(d: Date): number {
        return LgvTSHelper.monthDiff(d, new Date());
    }

    public static shortDateString(jsonDate: string): string {
        const datePipe = new DatePipe('en-US');
        return datePipe.transform(jsonDate, 'MM/dd/yy');
    }

    public static shortDateStringDate(date: Date): string {
        const datePipe = new DatePipe('en-US');
        return datePipe.transform(date, 'MM/dd/yy');
    }

    public static loanComparisonString(tag1: string, rate1: any, jDate1: any, tag2: string, rate2: any, jDate2: any) {
        return `${tag1}: ${LgvTSHelper.shortDateString(jDate1)} ${rate1}%  -  ${tag2}: ${LgvTSHelper.shortDateString(jDate2)} ${rate2}%`;
    }

    public static generateNewGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16).toUpperCase();
        });
    }

    public static imgSuffix() {
        return `?x=${Math.floor(Math.random() * 10000)}`;
    }

    public static onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    public static findClosestNumInSortedArray(sortedArray: number[], targetNum: number, defaultTarget: number): number {
        if (targetNum == null) {
            targetNum = defaultTarget;
        }

        if (sortedArray.indexOf(targetNum) != -1) {
            return targetNum;
        }


        let lowNum = -1;
        let lowNumDelta = -1;
        let highNum = -1;
        let highNumDelta = -1;

        for (const lock of sortedArray) {
            if (lock < targetNum) {
                lowNum = lock;
                lowNumDelta = targetNum - lock;
            }
            else {
                highNum = lock;
                highNumDelta = lock - targetNum;
                break;
            }
        }

        if (highNum == -1) { return lowNum; }

        return (highNumDelta <= lowNumDelta) ? highNum : lowNum;

    }

    public static isString(content: any): boolean {
        return typeof content === 'string'
    }

    //#region Param Helpers

    public static getParamArrayFromURL(url: string): string[] {

        const paramsString = url.split("?")[1];
        return !!paramsString ? paramsString.split('&') : [];
    }

    public static getParamValue(targetParam: string, params: string[]): string {
        let rtnVal = null;
        params.forEach(param => {
            let parts = param.split('=');
            if (parts.length === 2 && parts[0] === targetParam) {
                rtnVal = parts[1];
            }
        });
        return rtnVal;
    }

    public static getParamValueFromURL(targetParam: string, url: string): string {
        return this.getParamValue(targetParam, this.getParamArrayFromURL(url));
    }

    //#endregion Param Helpers

    //#region Color Helpers

    public static isDarkColor(color: string):boolean {

        if (!(!!color)) { return false; }

        // strip hash symbol
        if (color.startsWith('#')) {
            color = color.substr(1, color.length - 1);
        }
        return !(this.luma(color) >= 165);
    }

    public static getContrastingColor(color: string):string {
        return this.isDarkColor(color) ? '#FFF' : '#000';
    }

    // color can be a hx string or an array of RGB values 0-255
    public static luma(color): number {
        var rgb = (typeof color === 'string') ? this.hexToRGBArray(color) : color;
        if (!rgb) return 0; // Handle null case if hexToRGBArray returns null for invalid hex
        return (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]); // SMPTE C, Rec. 709 weightings
    }

    public static hexToRgbObject(hex: string): {r: number, g: number, b: number} | null {
        if (!hex) return null;
        let processedHex = hex.replace(/^#/, '');
    
        if (processedHex.length === 3) {
          processedHex = processedHex[0] + processedHex[0] + processedHex[1] + processedHex[1] + processedHex[2] + processedHex[2];
        }
    
        if (processedHex.length !== 6) {
            return null; // Invalid hex length
        }

        const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(processedHex);
        return result
          ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            }
          : null;
      }

    public static hexToRGBArray(color: string): number[] | null {
        const rgbObject = this.hexToRgbObject(color);
        if (rgbObject) {
            return [rgbObject.r, rgbObject.g, rgbObject.b];
        }

        return null;
    }

    public static hexToRgbString(hex: string): string | null {
        const rgbObject = this.hexToRgbObject(hex);
        if (rgbObject) {
            return `${rgbObject.r}, ${rgbObject.g}, ${rgbObject.b}`;
        }
        return null;
    }

    //#endregion Color Helpers

    public static get environmentBaseUrl(): string {
        return window.location.origin + '/';
    }

    public static isValidStateCode(state: string) {

        let validStates = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO',
            'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

        return validStates.includes(state);
    }

}
